














import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Container from '@/components/Container.vue';
import Card from '@/components/Card.vue';
import BillingAddressForm from './components/BillingAddressForm.vue';
import {
  Product,
  ApplicationState
} from '@/store/modules/application/types/application.types';
import {
  CreateOrderPayload,
  BillingAddress,
  CreateOrderResponse
} from '@/store/modules/order/order.types';
import { AxiosResponse } from 'axios';
import { ApiState } from '@/store/types/general.types';

@Component({
  components: {
    ValidationObserver,
    Container,
    Card,
    BillingAddressForm
  }
})
export default class ProductCheckoutPage extends Vue {
  @State(({ order }: RootState) => order.apiState.createOrder)
  public createOrderState!: ApiState;

  @Action('application/getProduct')
  public getProduct!: ({ productId }: { productId: number }) => Promise<void>;

  @Action('order/createOrder')
  public createOrder!: (payload: CreateOrderPayload) => Promise<AxiosResponse>;

  @State(({ application }: RootState) => application.product)
  public product!: Product;

  get productId() {
    return +this.$route.params.productId;
  }

  public async handlePayment(billingAddress: BillingAddress) {
    const response: AxiosResponse<CreateOrderResponse> = await this.createOrder(
      {
        productId: this.product.id,
        billingAddress
      }
    );
    if (!response) {
      return this.showPaymentError();
    }
    this.redirectPaymentGateway(response.data);
  }

  public redirectPaymentGateway(response: CreateOrderResponse) {
    if (response.paymentRequired) {
      if (response.purchasePaymentUrl) {
        return (window.location.href = response.purchasePaymentUrl);
      }

      const responseText =
        'Unable to connect to payment gateway due to invalid login credential. Please contact an administrator.';

      return this.$buefy.dialog.confirm({
        title: 'Error',
        message: `<p class="subtitle"> ${responseText}<p>`,
        confirmText: 'Try again',
        canCancel: ['button'],
        onConfirm: () => {
          this.redirectPaymentGateway(response);
        },
        cancelText: 'Cancel',
        onCancel: () => {
          this.cancelPurchase();
        }
      });
    }
  }

  public cancelPurchase() {
    return this.$router.push('/');
  }

  public async mounted() {
    await this.getProduct({ productId: this.productId });
  }

  showPaymentError() {
    const responseText =
      'Unable to connect to payment gateway. Please try again later.';

    return this.$buefy.dialog.confirm({
      title: `Error`,
      message: `<p class="subtitle"> ${responseText}<p>`,
      confirmText: 'OK'
    });
  }
}
